import React from 'react'
import { unansweredQuestionTypeLabels } from '../configs'

import { useUnknownQuestions } from '../context'
import { TypeButtonGroup, TypeOption } from './styles'

type QuestionTypeButtonGroupProps = {
  questionTypes: string[]
}

export const QuestionTypeButtonGroup = ({questionTypes}: QuestionTypeButtonGroupProps) => {
  const { removeFilter, addFilterParam, filter } = useUnknownQuestions()

  const onTypeChange = (buttonType: string) => {
    if (filter?.type === buttonType) {
      removeFilter('type')
    } else {
      addFilterParam('type', buttonType)
    }
  }

  return (
    <TypeButtonGroup>
      {questionTypes.map(option => (
        <TypeOption key={option} onClick={() => onTypeChange(option)} isActive={filter?.type === option}>
          {unansweredQuestionTypeLabels[option] || option}
        </TypeOption>
      ))}
    </TypeButtonGroup>
  )
}
